// OQ-3/R3 (pre-impl review) — locates this pipeline's owning App Instance by finding it
// inside the already-loaded grouped `GET /api/pipelines` response (`PipelineGroupDto[]`),
// rather than fanning out a `useGetDetailAppInstance` call across every App Instance.
// `PipelineDto` itself carries no `AppInstanceId` (confirmed at apis.js/useGetDetailPipeline),
// so this is the ONLY FE-only way to resolve it.
//
// Returns `null` when the pipeline is absent from every group — an orphaned pipeline whose
// container was soft-deleted (RV-6) — so callers can render a graceful "container
// unavailable" fallback (AC-7) instead of a raw id or a dead link.
export const resolvePipelineAppInstanceId = (groupedList = [], pipelineId) => {
	const group = (groupedList ?? []).find(g => (g?.Pipelines ?? []).some(p => p?.Id === pipelineId));
	return group?.AppInstanceId ?? null;
};

export default resolvePipelineAppInstanceId;
